module.exports = __webpack_public_path__ + "static/media/murphy.d5b3ff4b.png";